import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    searchField: {
        padding: '10px 14px',
        borderRadius: '14px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderWidth: '1px',
        borderStyle: 'solid',
        maxWidth: '400px',
        width: '100%',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
